import { UseLoadingReturn } from "@/hooks/use-loading";
import useUpdate from "@/hooks/use-update";
import { IListPriceInput } from "@/interfaces/list-price.interface";
import { listPriceService } from "@/services/list-price.service";
import { UpdateByIdProps } from "@/types/requests.types";

export type UpdateListPriceProps = UpdateByIdProps<IListPriceInput>;

export type UseUpdateListPriceReturn = {
  update: (props: UpdateListPriceProps) => Promise<void>;
} & UseLoadingReturn;

const useUpdateListPrice = (): UseUpdateListPriceReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, update } = useUpdate<IListPriceInput>({
    operation: (formData, listPriceId) => listPriceService.update(formData, listPriceId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    update,
  };
};
export default useUpdateListPrice;
